RivalIQ.module('export.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    const ScheduledReport = models.ScheduledReport = models.Report.extend({
        url: function () {
            const me = this;
            return `/api/landscapes/${me.get('landscapeId')}/report/scheduled`;
        },

        action: RivalIQ.export.type.SCHEDULE,

        exportSuccessMsg: 'Your scheduled report has been created!',
        exportErrorMsg: 'We had an issue exporting your report.  Please try again.',

        initialize: function (attrs, options) {
            const me = this;

            models.Report.prototype.initialize.apply(me, arguments);

            // echo email events
            me.listenTo(attrs.emails, 'all', function (event) {
                me.trigger(`emails:${event}`, Array.prototype.slice.call(arguments, 1));
            });

            me.dashboardModel = _.get(options, 'dashboardModel');
        },

        parse: function (attrs) {
            attrs.emails = new RivalIQ.collections.Emails(_.map(attrs.emails, function (email) {
                return {
                    email: email
                };
            }));

            return attrs;
        },

        toJSON: function () {
            const me = this;

            return _.extend({}, me.attributes, {
                emails: me.get('emails').toJSON()
            });
        },

        toScheduleAttributes: function () {
            const me = this;

            const viewState = RivalIQ.state.view.pick('landscapeId', 'companySetDescriptor', 'timeZone');
            const advancedSettingsEnabled = _.result(me.dashboardModel, 'scheduledExportAdvancedSettingsEnabled', true);

            return _.extend({}, me.attributes, {
                path: me.dashboardModel.getBasePath(),
                props: me.dashboardModel.getPropsForSchedule(me.get('format')),
                state: viewState,
                advancedSettingsEnabled: advancedSettingsEnabled
            });
        },

        dialogRequired: function () {
            return false;
        },

        validate: function (attrs) {
            const errors = [];

            if (!_.exists(attrs.format)) {
                errors.push(['format', 'Please pick a filetype']);
            }

            if (!_.exists(attrs.emails) || !attrs.emails.length) {
                errors.push(['email', 'Please tell us where to send the report']);
            }

            if (!errors.length) {
                return null;
            }

            return errors;
        }
    });

    ScheduledReport.action = RivalIQ.export.type.SCHEDULE;
});
